import React from 'react'
import { connect } from 'react-redux';
import { change as changeFieldValue, reduxForm } from 'redux-form';
import ReactTooltip from 'react-tooltip';
import { formatarReal } from '../../util/numberUtil';
import DetalheEncomenda from './DetalheEncomenda';
import alterarExibicaoEncomenda from '../../actions/encomenda/alterarExibicaoEncomenda';
import buscarEncomenda from '../../actions/encomenda/buscarEncomenda';
import buscarEncomendas from '../../actions/encomenda/buscarEncomendasEmpresa';
import buscarEncomendaItinerario from '../../actions/encomenda/buscarEncomendaItinerario';
import selecionarEncomenda from '../../actions/encomenda/selecionarEncomenda';

export class EncomendaBaixaEntrega extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imagensInformarEntrega: [],
    }
  }

  getEncomendaBadgeClass(situacao) {
    if (!situacao) return 'vx-gp-badge--default';
    const s = situacao.toUpperCase();
    if (s.includes('APROVADO') || s.includes('ENTREGUE') || s.includes('CONFIRMADO')) return 'vx-gp-badge--aprovado';
    if (s.includes('CANCELADO') || s.includes('RECUSADO')) return 'vx-gp-badge--cancelado';
    if (s.includes('PENDENTE') || s.includes('ABERTO') || s.includes('AGUARDANDO') || s.includes('TR')) return 'vx-gp-badge--pendente';
    return 'vx-gp-badge--default';
  }

  exibirBotaoEmbarqueDesembarque(encomenda) {
    if (encomenda.dataHoraEmbarque && !encomenda.dataHoraDesembarque) {
      return (
        <button type="button" data-toggle="modal"
          data-target="#modalConfirmarEmbarqueDesembarqueEncomenda"
          className="vx-bag-btn vx-bag-btn--desembarcar"
          onClick={() => this.props.selecionarEncomendaEmbarqueDesembarque(encomenda)}>
          <span className="material-icons" style={{ fontSize: 13 }}>directions_bus</span>
          Desembarcar
        </button>
      )
    }
    if (!encomenda.dataHoraEmbarque) {
      return (
        <button type="button" data-toggle="modal"
          data-target="#modalConfirmarEmbarqueDesembarqueEncomenda"
          className="vx-bag-btn vx-bag-btn--embarcar"
          onClick={() => this.props.selecionarEncomendaEmbarqueDesembarque(encomenda)}>
          <span className="material-icons" style={{ fontSize: 13 }}>directions_bus</span>
          Embarcar
        </button>
      )
    }
    if (encomenda.dataHoraDesembarque) {
      return <span style={{ fontSize: 11, color: '#2e7d32', fontWeight: 700 }}>✓ Desembarcado</span>
    }
  }

  render() {
    const encomenda = this.props.encomenda;
    const isOpen = encomenda.exibirDetalhe;
    return (
      <div className={`vx-gp-row${isOpen ? ' vx-gp-row--open' : ''}`}>
        <div className="vx-gp-row-main vx-gp-row-main--encomenda-baixa">
          <div className="vx-gp-toggle" onClick={() => this.props.alterarExibicaoEncomenda(encomenda)}>
            <span className="material-icons">{isOpen ? 'expand_less' : 'expand_more'}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Embarque/Desembarque</span>
            {this.exibirBotaoEmbarqueDesembarque(encomenda)}
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Nº Pedido</span>
            <span className="vx-gp-field-value">{encomenda.idPedido}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Vendedor</span>
            <span className="vx-gp-field-value">{encomenda.nomeVendedor}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Descrição</span>
            <span className="vx-gp-field-value">{encomenda.descricaoProduto}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Remetente</span>
            <span className="vx-gp-field-value">{encomenda.remetente.nome}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Data Emissão</span>
            <span className="vx-gp-field-value">{encomenda.dataCriacao}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Status</span>
            <span className={`vx-gp-badge ${this.getEncomendaBadgeClass(encomenda.ultimoHistorico.descricaoSituacao)}`}>
              {encomenda.ultimoHistorico.descricaoSituacao}
            </span>
          </div>
          <div className="vx-gp-field vx-gp-field--price">
            <span className="vx-gp-field-label">Valor</span>
            <span className="vx-gp-field-value">{formatarReal(encomenda.valorTotal)}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Confirmar Entrega</span>
            {encomenda.sePodeInformarEntrega !== false
              ? <button type="button"
                  className="vx-bag-btn vx-bag-btn--receipt"
                  style={{ width: 'auto' }}
                  data-toggle="modal"
                  data-target="#modalInformarEntregaEncomenda"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.changeFieldValue('formularioInformarEntregaEncomenda', 'observacao', encomenda.observacaoEntrega);
                    this.props.preencherModalInformarEntregaEncomenda(encomenda.imagensInformarEntrega);
                    this.props.selecionarEncomenda(encomenda);
                  }}>
                  Informar entrega
                </button>
              // depois de finalizada, some o botão de ação e aparece só o
              // indicador de histórico, com tooltip "Entregue por X em Y"
              : <span data-tip data-for={`entrega-encomenda-${encomenda.id}`}
                  style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>
                  <span className="material-icons" style={{ fontSize: 18, color: '#2e7d32' }}>history</span>
                  <ReactTooltip id={`entrega-encomenda-${encomenda.id}`} type="dark" effect="solid">
                    Entregue por {encomenda.nomeUsuarioEntrega} em {encomenda.dataEntrega}
                  </ReactTooltip>
                </span>}
          </div>
        </div>
        <DetalheEncomenda encomenda={encomenda} />
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    encomendas: state.encomendas.encomendas,
    empresaSelecionada: state.empresaSelecionada
  });

export default connect(mapStateToProps,
  {
    selecionarEncomenda,
    buscarEncomendaItinerario,
    buscarEncomendas,
    buscarEncomenda,
    changeFieldValue,
    alterarExibicaoEncomenda
  })(reduxForm({
    form: 'formularioCadastroEncomenda'
})(EncomendaBaixaEntrega))